import { CheckCircle, Cancel, PauseCircle } from '@mui/icons-material'
import React from 'react'

export const getDecisionIcon = (decision?: string): React.ReactElement | null => {
	switch (decision) {
		case 'Approved':
			return <CheckCircle fontSize='small' />
		case 'Declined':
			return <Cancel fontSize='small' /> 
		case 'OnHold':
			return <PauseCircle fontSize='small' />
		default:
			return null
	}
}

export const getDecisionColor = (decision?: string): 'success' | 'error' | 'warning' => {
	switch (decision) {
		case 'Approved':
			return 'success'
		case 'Declined':
			return 'error'
		case 'OnHold':
			return 'warning'
		default:
			return 'success'
	}
}

export const getDecisionSeverity = (decision?: string): 'success' | 'error' | 'warning' | 'info' => {
	switch (decision) {
		case 'Approved':
			return 'success'
		case 'Declined':
			return 'error'
		case 'OnHold':
			return 'warning'
		default:
			return 'info'
	}
}

